import { computed, observable, makeObservable } from 'mobx';
import { TickingClock } from '../clock/TickingClock';
import { runtime } from '../../Runtime';

export class TimeSwitch {
  readonly tickingClock: TickingClock;
  readonly switchTime: number;
  @observable didReachSwitchMark: boolean = false;

  constructor(tickingClock: TickingClock, switchTime: number) {
    makeObservable(this);
    this.tickingClock = tickingClock;
    this.switchTime = switchTime;
  }

  @computed
  get hasPassed(): boolean {
    return !this.isBelow;
  }

  @computed
  get isBelow(): boolean {
    if (this.didReachSwitchMark) return false;
    const isActive = this.tickingClock.tickingTime < this.switchTime;
    if (!isActive) {
      // kill observing
      runtime.runtimeScheduler.scheduleForAnimationFrame(() => (this.didReachSwitchMark = true));
    }
    return isActive;
  }
}
